// removed by extract-text-webpack-plugin
module.exports = {"error-wrap":"error-wrap--1YeAzU","logo":"logo--1Q6PU2","name":"name--2DgYUB","error":"error--3-jiBy","btn":"btn--2CTqHn"};